/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcRssRegular({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path d="M7 16a2 2 0 1 1 0 4 2 2 0 0 1 0-4m-1.5-6a9.5 9.5 0 0 1 9.486 10h-1.803q.016-.248.017-.5A7.7 7.7 0 0 0 5 11.817v-1.804A10 10 0 0 1 5.5 10" />
      <path d="M5.5 4C14.06 4 21 10.94 21 19.5q0 .25-.009.5h-1.8q.009-.25.01-.5c0-7.566-6.135-13.7-13.701-13.7q-.25 0-.5.01V4.009Q5.25 4 5.5 4" />
    </svg>
  );
}
export default IcRssRegular;
